<!-- <div class="main-wrapper d-none">
    <app-header></app-header>
    <div class="app-body position-relative">
        <app-sidebar></app-sidebar>
        <main class="main">
            <div class="row">
              <div class="col-md-12">
                <div class="divider-top">
                  <div class="card card-report card-accent-primary mb-3">
                    <div class="card-body p-0">
                      <div class="betHistory">
                        <div class="row">
                          <div class="col-md-4 col-6"> 
                            <div class="input-group mb-2">
                                <input type="text" class="form-control" [popover]="popTemplateStatementStart"
                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                value="{{statementStartDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                              <span class="input-group-text"><i class="fa fa-calendar-o"></i></span>
                            </div>                                      
                          </div>
                          <div class="col-md-4 col-6">
                            <div class="input-group mb-2">
                                <input type="text" class="form-control" [popover]="popTemplateStatementEnd"
                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                value="{{statementEndDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                              <span class="input-group-text"><i class="fa fa-calendar-o"></i></span>
                            </div>                                      
                          </div>                                    
                          <div class="col-md-4 col-6">
                            <div class="form-group mb-2">
                              <button class="btn btn-primary" type="button" (click)="getStatement(undefined,'filterBtnClick');rerender()"><strong>Get Statement</strong></button>
                            </div>                                      
                          </div>
                        </div>
                      </div>
                    </div>  
                  </div>
                  <div class="card card-accent-primary">
                    <div class="card-header account-detail-head">Account Statement</div>
                    <div class="card-body account-stat-body">
                      <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive">
                            <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                <thead>
                                    <tr class="text-center">
                                        <th>Date & Time</th>
                                                <th>Deposit</th>
                                                <th>Withdrawl</th>
                                                <th>Balance</th>
                                                <th>Remark</th>
                                                <th>From / To</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="statementsDataSource?.length != 0">
                                    <tr *ngFor="let data of statementsDataSource;let i = index;" style="text-align: center;">
                                        <td>{{data.date | date: 'dd-MM-yyyy hh:mm:ss aa'}}</td>
                                        <td  [ngClass]="{'text-success':data.credit_debit >= 0}"> {{data.credit_debit > '0' ? (data.credit_debit | number :'0.0-2') : '0'}}</td>
                                        <td [ngClass]="{'text-danger':data.credit_debit < 0}">{{data.credit_debit < '0' ? (data.credit_debit | number :'0.0-2') : '0'}}</td>
                                        <td  [ngClass]="{'text-danger':data.balance < 0 ,'text-success':data.balance >= 0}">{{data.balance| number :'0.0-2'}}</td>
                                        <td>{{data?.remark}}</td>
                                        <td>{{data?.description}}</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="statementsDataSource?.length == 0">
                                    <tr>
                                      <td class="no-data-available" colspan="6">No data!</td>
                                    </tr>
                                  </tbody>
                            </table>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </main>
        <app-right-sidebar></app-right-sidebar>                   
    </div>
    <app-footer-main></app-footer-main>
</div> -->

<div class="wrapper">
  <app-header></app-header>
  <div class="main">
      <div class="container-fluid container-fluid-5">
          <div class="row row5">
              <div class="sidebar col-md-2 hide-small">
                  <app-sidebar></app-sidebar>
              </div>
              <div class="col-12 hide-large featured-box">
              </div>
              <div class="col-md-10 report-main-content m-t-5">
                <div class="card">
                  <div class="card-header"><h4 class="mb-0">Account Statement</h4></div>
                  <div class="card-body container-fluid container-fluid-5">
                    <div class="row row5">
                        <div class="col-md-2 col-sm-2 col-6">
                          <div class="mx-input-wrapper">
                            <input type="text" class="mx-input" [popover]="popTemplateStatementStart"
                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                value="{{statementStartDate | date:'yyyy-MM-dd'}}" (click)="showDate()" (keyup)="onChangeDateInput($event,'start')">
                            <span class="mx-input-append"><i class="fa fa-calendar-o"></i></span>
                            <P style="color: red;" *ngIf="showStartDateInputError">Please enter valid Date</P>
                          </div>
                        </div>
                        <div class="col-md-2 col-sm-2 col-6">
                          <div class="mx-input-wrapper">
                            <input type="text" class="mx-input" [popover]="popTemplateStatementEnd"
                            placement="bottom" [outsideClick]="true" #endpopoverRef="bs-popover"
                            value="{{statementEndDate | date:'yyyy-MM-dd'}}" (click)="showDate()" (keyup)="onChangeDateInput($event,'end')">
                            <span class="mx-input-append"><i class="fa fa-calendar-o"></i></span>
                            <P style="color: red;" *ngIf="showEndDateInputError">Please enter valid Date</P>
                          </div>
                        </div>
                        <div class="col-sm-2 col-md-2 col-12 btn-col">
                          <div class="form-group mb-0">
                            <select name="statementType" class="form-select" placeholder="Please Select Report Type" [(ngModel)]="statementType"
                                [ngModelOptions]="{standalone: true}" aria-label="Default select example" >
                              <option  value="" disabled selected>Please Select Report Type</option>
                              <option class="select-option"   value="0">All</option>
                              <option class="select-option"   value="6">Game Report</option>
                              <option class="select-option"   value="5">Balance Report</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-1 col-sm-1 col-12 btn-col">
                          <button class="btn btn-primary btn-block mobile-width" (click)="submit()" [disabled]="showStartDateInputError || showEndDateInputError">Submit</button>
                        </div>
                    </div>
                    <div class="row row5 mt-2">
                        <div class="col-12 account-statement-tbl">
                          <div class="table-responsive statementTable">
                            <table class="table b-table table-striped table-bordered dataTable"  datatable [dtOptions]="dtOptions"
                                                [dtTrigger]="dtTrigger" >
                            </table>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</div>

<app-footer-main></app-footer-main>

<!-- Date Time Picker -->
<ng-template #popTemplateStatementStart >
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateStatement" [ngModelOptions]="{standalone: true}" [minDate]="minDate"  [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime" (ngModelChange)="updateTimeStatement()" [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today('start')">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear('start')">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplateStatementEnd>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateStatement" [ngModelOptions]="{standalone: true}" [minDate]="dateStatement" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateEndDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime"  (ngModelChange)="updateEndTimeStatement()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today('end')">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear('end')">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>


<ng-template #bets>
  <!-- <div class="modal-header">
      <h4 class="modal-title">Bet List </h4>
      <a type="button" class="close" data-dismiss="modal" (click)="modalRef.hide();"><i
              class="fa fa-times"></i></a>
  </div> -->
  <div class="modal-body">
    <div class="container-fluid container-fluid-5">
        <div class="row row5">
          <div class="col-12 text-center">
            <div id="match_delete" class="radio-group" role="radiogroup" tabindex="-1">
              <div class="custom-control custom-control-inline custom-radio">
                <input id="matched" type="radio" name="match_delete" autocomplete="off" value="1" class="custom-control-input" checked> 
                <label for="matched" class="custom-control-label"><span>Matched</span></label>
              </div> 
              <div class="custom-control custom-control-inline custom-radio">
                <input id="deleteed" type="radio" name="match_delete" autocomplete="off" value="2" class="custom-control-input"> 
                <label for="deleteed" class="custom-control-label"><span>Deleted</span></label>
              </div>
            </div>
          </div>
        </div>
        <div class="row row5 hide-small">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table b-table table-bordered">
                  <thead>
                      <tr>
                          <th class="text-right">No</th>
                          <th class="text-center">Nation</th>
                          <th class="text-center">Side</th>
                          <th class="text-right">Rate</th>
                          <th class="text-right">Amount</th>
                          <th class="text-right">Win/Loss</th>
                          <th class="text-center">Place Date</th>
                          <th class="text-center">Match Date</th>
                      </tr>
                  </thead>
                  <tbody *ngIf="settledBetData?.length != 0">
                    <ng-container  *ngFor="let bet of settledBetData;let i = index;">
                      <tr [ngClass]="{'back':bet?.is_back == 1,'lay':bet?.is_back == 0}">
                        <td class="text-right">1</td>
                        <td class="text-center">{{(bet?.is_fancy == 1) ? (bet?.market_name) : (bet?.selection_name)}}</td>
                        <td class="text-center" *ngIf="bet?.is_fancy == 0">{{bet?.is_back == 1 ? 'BACK' : 'LAY'}}</td>
                        <td class="text-center" *ngIf="bet?.is_fancy == 1">{{bet?.is_back == 1 ? 'YES' : 'NO'}}</td>
                        <td class="text-right">{{bet?.updateOdds}}</td>
                        <td class="text-right">{{bet?.stack}}</td>
                        <td class="text-right" [ngClass]="{'red':bet?.updatePl < 0,'green':bet?.updatePl >= 0}">{{(bet?.updatePl)| number : '0.0-2'}}</td>
                        <td class="text-center">{{moment(bet?.createdAt).utcOffset("+0").format('DD-MM-yy hh:mm:ss a')}}</td>
                        <td class="text-center">{{moment(bet?.createdAt).utcOffset("+0").format('DD-MM-yy hh:mm:ss a')}}</td>
                    </tr>
                    </ng-container>
                  </tbody>
                  <tbody *ngIf="settledBetData?.length == 0">
                      <tr>
                          <td colspan="9" class="text-center">No Record Found..</td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row row5 hide-large" *ngIf="settledBetData?.length != 0">
          <div class="col-12 padding-col">
            <ng-container  *ngFor="let bet of settledBetData;let i = index;">
              <div class="account-statement" [ngClass]="{'back':bet?.is_back == 1,'lay':bet?.is_back == 0}">
                <div class="row row5">
                  <div class="col-6">
                    <div><b>Nation:</b> {{(bet?.is_fancy == 1) ? (bet?.market_name) : (bet?.selection_name)}}</div> 
                    <div><b>Placed Date:</b> {{moment(bet?.createdAt).utcOffset("+0").format('DD-MM-yy hh:mm:ss a')}}</div> 
                    <div><b>Matched Date:</b> {{moment(bet?.createdAt).utcOffset("+0").format('DD-MM-yy hh:mm:ss a')}}</div>
                  </div> 
                  <div class="col-2 text-right">
                    <div><b>Rate</b></div> 
                    <div>{{bet?.updateOdds}}</div>
                  </div> 
                  <div class="col-2 text-right">
                    <div><b>Amount</b></div> 
                    <div>{{bet?.stack}}</div>
                  </div> 
                  <div class="col-2 text-right">
                    <div><b>W&amp;L</b></div> 
                    <div [ngClass]="{'red':bet?.updatePl < 0,'green':bet?.updatePl >= 0}">{{(bet?.updatePl)| number : '0.0-2'}}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" (click)="modalRef.hide();">Close</button>
  </div>
</ng-template>